import styled from 'styled-components'

export const SoftwareUpdateStatusContainer = styled.div`
  word-break: break-word;
`
